
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as bekreftLDryy_tjAHrmxVnhAH7BenHKftpCW1wx4HQdzNo5C4oMeta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/logg-inn/bekreft.vue?macro=true";
import { default as callback_46clientF4YEgFOiWZmmc0KWbtyPJPpvW_IZzBUNH8SWpjSV0uQMeta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/login/callback.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/builds/aschehoug/aschehoug-utdanning/shop-app/node_modules/.pnpm/nuxt@4.4.8_@azure+identity@4.13.0_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7__@_00b3dff35a68ba611337aee823d6f564/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as _91event_93eexHRt_6KuytzDCYHtmF_xukrIJOHQNvzznQXEFN9UUMeta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/arrangementer/[event].vue?macro=true";
import { default as _91slug_93f1aDc4rIDCRl1D42vYhgQqtKDYYZBwu3WQPfNxZQSagMeta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/artikler/[slug].vue?macro=true";
import { default as _91slug_93aG_cCaPpC8TxnTsfjcSFnOVkm6p8_hUZ8E3znYLEf1oMeta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/podkaster/[slug].vue?macro=true";
import { default as _91slug_937VdGvsurd0oI8Hp_6aS9hMM05OhmhKybZqw3mMNGrn8Meta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/produktkatalog/[slug].vue?macro=true";
import { default as indexwkPQRc3S1c07cR7wlo8fOE__HyBP_TSXGwrDnsliMOkMeta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/arrangementer/index.vue?macro=true";
import { default as indexViDW_asXJ3sBMLpE2kwctaYUL7noB81gcsZjcD3leaIMeta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/artikler/index.vue?macro=true";
import { default as brukerinvolveringKKqolElJ92PiIOZRL4W8coK8AsFYtfS85ikeuZ172rwMeta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/brukerinvolvering.vue?macro=true";
import { default as handlekurvo4kRhBIGIwMXLnjspVac00QIKjLGwKTXlz_xYSjThp0Meta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/handlekurv.vue?macro=true";
import { default as informasjonskapslerIv_M_5bhRc3hcyLPxUQ2DT7yd88jZ_6zQ0JdR8neYHYMeta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/informasjonskapsler.vue?macro=true";
import { default as kjopsbetingelsernbeQuWYua8hR4p_KihZdaErVeKpKjrrh7lleYWKDZlMMeta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/kjopsbetingelser.vue?macro=true";
import { default as kundeservice9gy1UHVyFLZ5YzgKd4KXCs_RgtELCZGbj3Yc8k2GNIoMeta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/kundeservice.vue?macro=true";
import { default as indexle_QSMpPBqYyDq5ZnHov3VhAP3GB7nuibuq7KDZpZxIMeta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/logg-inn/index.vue?macro=true";
import { default as minsidenKgM2P90FXNLoR5C66f_P43rPJOo0OuqH498sVvPqpkMeta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/minside.vue?macro=true";
import { default as nyhetsbrevo4oRV12kBZTH6GwnUuczT3_LUKgYe1HT45LTl7XL2tgMeta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/nyhetsbrev.vue?macro=true";
import { default as om_45aschehougtWbFuydF9LqttDYqXwSGNqFylbglGjMpHQB1wOAqn5gMeta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/om-aschehoug.vue?macro=true";
import { default as personvernKgPpIZyRDqnhPWWvIwHXfWPqTWpGupgjgKVUPMDpdrQMeta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/personvern.vue?macro=true";
import { default as indext72_R5nv0_aFUgL0KNPl5e1LJJO96SAc76CmQBgPdbIMeta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/podkaster/index.vue?macro=true";
import { default as indextgcRtYkVScM03RRhqhPNpV0b6zkyhRmZxaQ1caaJ6WkMeta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/produktkatalog/index.vue?macro=true";
import { default as sokwIhhxiJL_faX89SxpzOAhnInphObrQoKqTntSpmg6asMeta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/sok.vue?macro=true";
import { default as takkL_4TJ97_I3vOKqG1DXiwdGuLAvU7ifDy2LkkZ4vDtOgMeta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/takk.vue?macro=true";
import { default as _91_46_46_46slug_93MSjDSWC3iY_cdCNoNufWGZ6rrPqlqNjYhLk_Xr9AzaoMeta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/[...slug].vue?macro=true";
import { default as indexb5vEHX6Klu1XI2VbqAkKCThlJO_t4u9knmZoWcNszL8Meta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/index.vue?macro=true";
import { default as component_45stubBpgn9akt40goux9cS0WFe_j7YAJwSJXTuytwikGeRwsMeta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/node_modules/.pnpm/nuxt@4.4.8_@azure+identity@4.13.0_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7__@_00b3dff35a68ba611337aee823d6f564/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubBpgn9akt40goux9cS0WFe_j7YAJwSJXTuytwikGeRws } from "/builds/aschehoug/aschehoug-utdanning/shop-app/node_modules/.pnpm/nuxt@4.4.8_@azure+identity@4.13.0_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7__@_00b3dff35a68ba611337aee823d6f564/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "login-confirm",
    path: "/logg-inn/bekreft",
    meta: {"middleware":["check-auth"]},
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/logg-inn/bekreft.vue").then((m) => Object.assign(m.default, { __name: bekreftLDryy_tjAHrmxVnhAH7BenHKftpCW1wx4HQdzNo5C4oMeta?.name ?? "login-confirm" }))
  },
  {
    name: "login-callback",
    path: "/login/callback",
    component: () => createClientPage(() => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/login/callback.client.vue")).then((c) => Object.assign(c, { __name: callback_46clientF4YEgFOiWZmmc0KWbtyPJPpvW_IZzBUNH8SWpjSV0uQMeta?.name ?? "login-callback" }))
  },
  {
    name: "event",
    path: "/arrangementer/:event()",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/arrangementer/[event].vue").then((m) => Object.assign(m.default, { __name: _91event_93eexHRt_6KuytzDCYHtmF_xukrIJOHQNvzznQXEFN9UUMeta?.name ?? "event" }))
  },
  {
    name: "article",
    path: "/artikler/:slug()",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/artikler/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93f1aDc4rIDCRl1D42vYhgQqtKDYYZBwu3WQPfNxZQSagMeta?.name ?? "article" }))
  },
  {
    name: "podcast",
    path: "/podkaster/:slug()",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/podkaster/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93aG_cCaPpC8TxnTsfjcSFnOVkm6p8_hUZ8E3znYLEf1oMeta?.name ?? "podcast" }))
  },
  {
    name: "product",
    path: "/produktkatalog/:slug()",
    meta: _91slug_937VdGvsurd0oI8Hp_6aS9hMM05OhmhKybZqw3mMNGrn8Meta || {},
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/produktkatalog/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_937VdGvsurd0oI8Hp_6aS9hMM05OhmhKybZqw3mMNGrn8Meta?.name ?? "product" }))
  },
  {
    name: "events",
    path: "/arrangementer",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/arrangementer/index.vue").then((m) => Object.assign(m.default, { __name: indexwkPQRc3S1c07cR7wlo8fOE__HyBP_TSXGwrDnsliMOkMeta?.name ?? "events" }))
  },
  {
    name: "articles",
    path: "/artikler",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/artikler/index.vue").then((m) => Object.assign(m.default, { __name: indexViDW_asXJ3sBMLpE2kwctaYUL7noB81gcsZjcD3leaIMeta?.name ?? "articles" }))
  },
  {
    name: "brukerinvolvering",
    path: "/brukerinvolvering",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/brukerinvolvering.vue").then((m) => Object.assign(m.default, { __name: brukerinvolveringKKqolElJ92PiIOZRL4W8coK8AsFYtfS85ikeuZ172rwMeta?.name ?? "brukerinvolvering" }))
  },
  {
    name: "handlekurv",
    path: "/handlekurv",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/handlekurv.vue").then((m) => Object.assign(m.default, { __name: handlekurvo4kRhBIGIwMXLnjspVac00QIKjLGwKTXlz_xYSjThp0Meta?.name ?? "handlekurv" }))
  },
  {
    name: "informasjonskapsler",
    path: "/informasjonskapsler",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/informasjonskapsler.vue").then((m) => Object.assign(m.default, { __name: informasjonskapslerIv_M_5bhRc3hcyLPxUQ2DT7yd88jZ_6zQ0JdR8neYHYMeta?.name ?? "informasjonskapsler" }))
  },
  {
    name: "kjopsbetingelser",
    path: "/kjopsbetingelser",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/kjopsbetingelser.vue").then((m) => Object.assign(m.default, { __name: kjopsbetingelsernbeQuWYua8hR4p_KihZdaErVeKpKjrrh7lleYWKDZlMMeta?.name ?? "kjopsbetingelser" }))
  },
  {
    name: "kundeservice",
    path: "/kundeservice",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/kundeservice.vue").then((m) => Object.assign(m.default, { __name: kundeservice9gy1UHVyFLZ5YzgKd4KXCs_RgtELCZGbj3Yc8k2GNIoMeta?.name ?? "kundeservice" }))
  },
  {
    name: "login",
    path: "/logg-inn",
    meta: {"middleware":["check-auth"]},
    alias: ["/login"],
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/logg-inn/index.vue").then((m) => Object.assign(m.default, { __name: indexle_QSMpPBqYyDq5ZnHov3VhAP3GB7nuibuq7KDZpZxIMeta?.name ?? "login" }))
  },
  {
    name: "minside",
    path: "/minside",
    meta: {"middleware":["check-auth"]},
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/minside.vue").then((m) => Object.assign(m.default, { __name: minsidenKgM2P90FXNLoR5C66f_P43rPJOo0OuqH498sVvPqpkMeta?.name ?? "minside" }))
  },
  {
    name: "nyhetsbrev",
    path: "/nyhetsbrev",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/nyhetsbrev.vue").then((m) => Object.assign(m.default, { __name: nyhetsbrevo4oRV12kBZTH6GwnUuczT3_LUKgYe1HT45LTl7XL2tgMeta?.name ?? "nyhetsbrev" }))
  },
  {
    name: "om-aschehoug",
    path: "/om-aschehoug",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/om-aschehoug.vue").then((m) => Object.assign(m.default, { __name: om_45aschehougtWbFuydF9LqttDYqXwSGNqFylbglGjMpHQB1wOAqn5gMeta?.name ?? "om-aschehoug" }))
  },
  {
    name: "personvern",
    path: "/personvern",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/personvern.vue").then((m) => Object.assign(m.default, { __name: personvernKgPpIZyRDqnhPWWvIwHXfWPqTWpGupgjgKVUPMDpdrQMeta?.name ?? "personvern" }))
  },
  {
    name: "podcasts",
    path: "/podkaster",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/podkaster/index.vue").then((m) => Object.assign(m.default, { __name: indext72_R5nv0_aFUgL0KNPl5e1LJJO96SAc76CmQBgPdbIMeta?.name ?? "podcasts" }))
  },
  {
    name: "products",
    path: "/produktkatalog",
    meta: {"middleware":["migrate-product-formats"]},
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/produktkatalog/index.vue").then((m) => Object.assign(m.default, { __name: indextgcRtYkVScM03RRhqhPNpV0b6zkyhRmZxaQ1caaJ6WkMeta?.name ?? "products" }))
  },
  {
    name: "search",
    path: "/sok",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/sok.vue").then((m) => Object.assign(m.default, { __name: sokwIhhxiJL_faX89SxpzOAhnInphObrQoKqTntSpmg6asMeta?.name ?? "search" }))
  },
  {
    name: "receipt",
    path: "/takk",
    meta: takkL_4TJ97_I3vOKqG1DXiwdGuLAvU7ifDy2LkkZ4vDtOgMeta || {},
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/takk.vue").then((m) => Object.assign(m.default, { __name: takkL_4TJ97_I3vOKqG1DXiwdGuLAvU7ifDy2LkkZ4vDtOgMeta?.name ?? "receipt" }))
  },
  {
    name: "fallback",
    path: "/:slug(.*)*",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/[...slug].vue").then((m) => Object.assign(m.default, { __name: _91_46_46_46slug_93MSjDSWC3iY_cdCNoNufWGZ6rrPqlqNjYhLk_Xr9AzaoMeta?.name ?? "fallback" }))
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/index.vue").then((m) => Object.assign(m.default, { __name: indexb5vEHX6Klu1XI2VbqAkKCThlJO_t4u9knmZoWcNszL8Meta?.name ?? "index" }))
  },
  {
    name: component_45stubBpgn9akt40goux9cS0WFe_j7YAJwSJXTuytwikGeRwsMeta?.name,
    path: "/login",
    component: Object.assign(component_45stubBpgn9akt40goux9cS0WFe_j7YAJwSJXTuytwikGeRws, { __name: component_45stubBpgn9akt40goux9cS0WFe_j7YAJwSJXTuytwikGeRwsMeta?.name ?? undefined })
  },
  {
    name: component_45stubBpgn9akt40goux9cS0WFe_j7YAJwSJXTuytwikGeRwsMeta?.name,
    path: "/login/bekreft",
    component: Object.assign(component_45stubBpgn9akt40goux9cS0WFe_j7YAJwSJXTuytwikGeRws, { __name: component_45stubBpgn9akt40goux9cS0WFe_j7YAJwSJXTuytwikGeRwsMeta?.name ?? undefined })
  }
]